import DayJsUtils from '@date-io/dayjs'
import GlobalStyles from '@mui/material/GlobalStyles'
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import { reExportedColors } from '../index'

const dateSelectorStyles = {
    '.shared-date-selector.shared-date-selector': {
        margin: '8px 0',
        '& .MuiButtonBase-root': { padding: '6px' }
    },
    '.shared-date-selector-calendar.shared-date-selector-calendar .MuiPickersDay-daySelected': {
        backgroundColor: reExportedColors.DARK_GREY
    }
}

const DateSelector = ({
    disableFuture,
    disablePast,
    minDate,
    maxDate,
    onChange,
    value,
    className,
    validation,
    disabled
}) => (
    <>
        <GlobalStyles styles={dateSelectorStyles} />
        <MuiPickersUtilsProvider utils={DayJsUtils}>
            <KeyboardDatePicker
                allowKeyboardControl={false}
                autoOk
                className={`shared-date-selector ${className || ''}`}
                disabled={disabled}
                disableFuture={disableFuture}
                disableToolbar
                disablePast={disablePast}
                error={Boolean(validation)}
                format='YYYY-MM-DD'
                id='date-picker-inline'
                InputProps={{ readOnly: true }}
                KeyboardButtonProps={{ 'aria-label': 'change date' }}
                margin='normal'
                minDate={minDate}
                maxDate={maxDate}
                onChange={onChange}
                PopoverProps={{
                    classes: { paper: 'shared-date-selector-calendar' }
                }}
                value={value}
                variant='inline'
            />
        </MuiPickersUtilsProvider>
    </>
)

export default DateSelector
